export const borderWidth = 0.5;
export const guideColor = 'rgba(232,206,42,1.00)';
